{
  "version": 1,
  "asset_id": "77cea70c-212e-4645-93bf-b6184a8d8f7c",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/77cea70c-212e-4645-93bf-b6184a8d8f7c/support-group-1200.webp",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/77cea70c-212e-4645-93bf-b6184a8d8f7c/support-group-1200.webp",
  "original_filename": "support-group-1200.webp",
  "size": 92166,
  "content_type": "image/webp",
  "created_at": "2026-10-04T23:43:29Z"
}
